const PASSWORD_MIN_LENGTH = 8;  // rule in old code
const PASSWORD_MAX_LENGTH = 30; // maximum length in database
const USERNAME_MAX_LENGTH = 30; // maximum length in database
const numberRegex = new RegExp(/[0-9]/);
const letterRegex = new RegExp(/(?=.*[a-z])(?=.*[A-Z])/);

function isValidPassword(password) {
  return isLongEnough(password) && hasNumber(password) && hasLetters(password);
}

function isLongEnough(password) {
  return Boolean(password) && password.length >= PASSWORD_MIN_LENGTH;
}

function hasNumber(password) {
  return numberRegex.test(password);
}

function hasLetters(password) {
  return letterRegex.test(password);
}

export { isValidPassword, isLongEnough, hasNumber, hasLetters, PASSWORD_MAX_LENGTH, USERNAME_MAX_LENGTH };